import { ref } from "vue";
import { useRouter } from "vue-router";
import Swal from "sweetalert2";
import { authService } from "@/services/AuthService";
export function useForm() {
    const showVerificationInput = ref(false);
    const isRequestingCode = ref(false);
    const isPhoneVerified = ref(false);
    const verificationCode = ref("");
    const timeLeft = ref(0);
    const timerInterval = ref(null);
    const isActive = ref(false);
    const currentStep = ref(1);
    const progress = ref(0);
    const router = useRouter();
    const recaptchaVerifiedLogin = ref(false);
    const recaptchaVerifiedRegister = ref(false);
    const form = ref({
        step1: {
            name: "",
            id: "",
            email: "",
            password: "",
            confirmPassword: "",
            accountType: 0,
        },
        step2: {
            prefixCelular: "+58",
            prefixWhatsapp: "+58",
            address: "",
            city: "",
            state: 0,
            cellNumber: "",
            whatsappNumber: "",
            isPhoneVerified: false,
        },
        step3: {
            landline: "",
            commerceType: 0,
            website: "",
            instagramId: "",
            tiktokId: "",
        },
        step4: {
            facebookName: "",
            representativeName: "",
            representativeId: "",
            representativePhone: "",
            representativePosition: "",
        },
        login: {
            email: "",
            password: "",
        },
    });
    const errors = ref({
        step1: {
            name: "",
            id: "",
            email: "",
            password: "",
            confirmPassword: "",
            accountType: "",
        },
        step2: {
            address: "",
            city: "",
            state: "",
            cellNumber: "",
            whatsappNumber: "",
            isPhoneVerified: "",
        },
        step3: {
            landline: "",
            commerceType: "", // Ajuste aquí
            website: "",
            instagramId: "",
            tiktokId: "",
        },
        step4: {
            facebookName: "",
            representativeName: "",
            representativeId: "",
            representativePhone: "",
            representativePosition: "",
        },
    });
    const handleRecaptchaInputLogin = (token) => {
        console.log("reCAPTCHA token (login):", token); // Debugging
        recaptchaVerifiedLogin.value = !!token;
    };
    const handleRecaptchaInputRegister = (token) => {
        console.log("reCAPTCHA token (register):", token); // Debugging
        recaptchaVerifiedRegister.value = !!token;
    };
    // Función para solicitar el código de verificación
    async function requestVerificationCode(phoneNumber) {
        if (!phoneNumber) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Por favor ingrese un número de teléfono válido (11 dígitos)",
                customClass: {
                    confirmButton: "swal-button--confirm-custom",
                },
            });
            return;
        }
        try {
            isRequestingCode.value = true;
            const fullNumber = `${form.value.step2.prefixCelular}${form.value.step2.cellNumber}`;
            // Aquí iría la llamada a tu API para solicitar el código
            const response = await authService.requestVerificationCode(fullNumber);
            showVerificationInput.value = true;
            timeLeft.value = 60; // 60 segundos para el contador
            // Iniciar el contador regresivo
            if (timerInterval.value)
                clearInterval(timerInterval.value);
            timerInterval.value = setInterval(() => {
                if (timeLeft.value > 0) {
                    timeLeft.value--;
                }
                else {
                    if (timerInterval.value)
                        clearInterval(timerInterval.value);
                }
            }, 1000);
            Swal.fire({
                icon: "success",
                title: "Código enviado",
                text: "Se ha enviado un código de verificación a su número de teléfono",
                customClass: {
                    confirmButton: "swal-button--confirm-custom",
                },
            });
        }
        catch (error) {
            let errorMessage = "Hubo un problema al solicitar el código de verificación";
            console.log("Error ui", error);
            // Aquí intentamos obtener el mensaje del error
            if (error?.message) {
                errorMessage = error.message; // El error debería venir con el mensaje directamente
            }
            Swal.fire({
                icon: "error",
                title: "Error",
                text: errorMessage,
                customClass: {
                    confirmButton: "swal-button--confirm-custom",
                },
            });
        }
        finally {
            isRequestingCode.value = false;
        }
    }
    async function verifyCode() {
        if (!verificationCode.value || verificationCode.value.length !== 6) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Por favor ingrese un código válido de 6 dígitos",
                customClass: {
                    confirmButton: "swal-button--confirm-custom",
                },
            });
            return;
        }
        try {
            const fullNumber = `${form.value.step2.prefixCelular}${form.value.step2.cellNumber}`;
            // Llamada a la API con el número completo
            await authService.verifyCode(fullNumber, verificationCode.value);
            isPhoneVerified.value = true;
            form.value.step2.isPhoneVerified = true;
            showVerificationInput.value = false;
            if (timerInterval.value)
                clearInterval(timerInterval.value);
            Swal.fire({
                icon: "success",
                title: "Verificación exitosa",
                text: "Su número de teléfono ha sido verificado correctamente",
                customClass: {
                    confirmButton: "swal-button--confirm-custom",
                },
            });
        }
        catch (error) {
            isPhoneVerified.value = false;
            form.value.step2.isPhoneVerified = false;
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Código de verificación inválido",
                customClass: {
                    confirmButton: "swal-button--confirm-custom",
                },
            });
        }
    }
    function resetPhoneNumber() {
        form.value.step2.cellNumber = "";
        form.value.step2.isPhoneVerified = false; // Añade esto
        isPhoneVerified.value = false; // Añade esto
        showVerificationInput.value = false;
        verificationCode.value = "";
    }
    function validateTypeUser() {
        let errorsList = [];
        // Verificar si se ha seleccionado un tipo de cuenta
        if (!form.value.step1.accountType) {
            errorsList.push("Debes seleccionar un tipo de cuenta.");
        }
        // Actualizar los errores en el objeto de errores
        errors.value.step1 = {
            ...errors.value.step1,
            accountType: errorsList.includes("Debes seleccionar un tipo de cuenta.")
                ? "Debes seleccionar un tipo de cuenta."
                : "",
        };
        // Retornar si hay errores o no
        return errorsList.length === 0;
    }
    function validateStep1() {
        let errorsList = [];
        if (!form.value.step1.name)
            errorsList.push("El nombre es obligatorio.");
        if (!form.value.step1.id)
            errorsList.push("La cédula o RIF es obligatorio.");
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.value.step1.email))
            errorsList.push("El correo electrónico no es válido.");
        if (!(form.value.step1.password.length >= 8 &&
            /[a-zA-Z]/.test(form.value.step1.password) &&
            /[0-9]/.test(form.value.step1.password)))
            errorsList.push("La contraseña debe tener al menos 8 caracteres, una letra y un número.");
        if (form.value.step1.confirmPassword !== form.value.step1.password)
            errorsList.push("Las contraseñas no coinciden.");
        errors.value.step1 = {
            ...errors.value.step1,
            name: errorsList.includes("El nombre es obligatorio.")
                ? "El nombre es obligatorio."
                : "",
            id: errorsList.includes("La cédula o RIF es obligatorio.")
                ? "La cédula o RIF es obligatorio."
                : "",
            email: errorsList.includes("El correo electrónico no es válido.")
                ? "El correo electrónico no es válido."
                : "",
            password: errorsList.includes("La contraseña debe tener al menos 8 caracteres, una letra y un número.")
                ? "La contraseña debe tener al menos 8 caracteres, una letra y un número."
                : "",
            confirmPassword: errorsList.includes("Las contraseñas no coinciden.")
                ? "Las contraseñas no coinciden."
                : "",
        };
        return errorsList.length === 0;
    }
    function validateStep2() {
        let errorsList = [];
        if (!form.value.step2.address)
            errorsList.push("La dirección es obligatoria.");
        if (!form.value.step2.city)
            errorsList.push("La ciudad es obligatoria.");
        if (!form.value.step2.state)
            errorsList.push("El estado es obligatorio.");
        if (!form.value.step2.cellNumber)
            errorsList.push("El número celular debe tener 11 dígitos.");
        if (!/^\d{10}$/.test(form.value.step2.whatsappNumber))
            errorsList.push("El número de WhatsApp debe tener 11 dígitos.");
        if (!isPhoneVerified.value)
            errorsList.push("Debe verificar su número de teléfono celular.");
        errors.value.step2 = {
            ...errors.value.step2,
            address: errorsList.includes("La dirección es obligatoria.")
                ? "La dirección es obligatoria."
                : "",
            city: errorsList.includes("La ciudad es obligatoria.")
                ? "La ciudad es obligatoria."
                : "",
            state: errorsList.includes("El estado es obligatorio.")
                ? "El estado es obligatorio."
                : "",
            cellNumber: errorsList.includes("El número celular debe tener 11 dígitos.")
                ? "El número celular debe tener 11 dígitos."
                : "",
            whatsappNumber: errorsList.includes("El número de WhatsApp debe tener 11 dígitos.")
                ? "El número de WhatsApp debe tener 11 dígitos."
                : "",
            isPhoneVerified: errorsList.includes("Debe verificar su número de teléfono celular.")
                ? "Debe verificar su número de teléfono celular."
                : "",
        };
        return errorsList.length === 0;
    }
    function validateStep3() {
        let errorsList = [];
        if (form.value.step1.accountType == 1) {
            if (!form.value.step3.commerceType)
                errorsList.push("Debe seleccionar el tipo de comercio.");
        }
        errors.value.step3 = {
            ...errors.value.step3,
            commerceType: errorsList.includes("Debe seleccionar el tipo de comercio.")
                ? "Debe seleccionar el tipo de comercio."
                : "",
            instagramId: "",
            tiktokId: "",
        };
        return errorsList.length === 0;
    }
    function validateCurrentStep() {
        let isValid = true;
        let errorsList = [];
        if (currentStep.value === 1) {
            isValid = validateTypeUser();
            errorsList = Object.values(errors.value.step1).filter((error) => typeof error === "string");
        }
        else if (currentStep.value === 2) {
            isValid = validateStep1();
            errorsList = Object.values(errors.value.step1).filter((error) => typeof error === "string");
        }
        else if (currentStep.value === 3) {
            isValid = validateStep2();
            errorsList = Object.values(errors.value.step2).filter((error) => typeof error === "string");
        }
        else if (currentStep.value === 4) {
            isValid = validateStep3();
            errorsList = Object.values(errors.value.step3).filter((error) => typeof error === "string");
        }
        if (!isValid && errorsList.length > 0) {
            Swal.fire({
                title: "Advertencia",
                html: `
          <div style="padding: 15px; border: 1px solid #ddd; border-radius: 8px; background: #fafafa; color: #333;">
            <p style="font-size: 16px; font-weight: 600; margin-bottom: 10px;">Antes de pasar al siguiente paso, confirme lo siguiente:</p>
            <div style="font-size: 14px;">
              ${errorsList
                    .filter(Boolean)
                    .map((error) => `<p style="margin: 0; padding: 5px 0; border-bottom: 1px solid #eee;">${error}</p>`)
                    .join("")}
            </div>
          </div>
        `,
                icon: "warning",
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "swal-button--confirm-custom",
                    cancelButton: "swal-button--cancel-custom",
                },
                backdrop: `rgba(0,0,0,0.1)`,
            });
        }
        return isValid;
    }
    function updateStep(step) {
        currentStep.value = step;
        progress.value = ((step - 1) / (6 - 1)) * 100;
    }
    function nextStep() {
        if (validateCurrentStep()) {
            if (currentStep.value < 6) {
                updateStep(currentStep.value + 1);
            }
        }
    }
    function previousStep() {
        if (currentStep.value > 1) {
            updateStep(currentStep.value - 1);
        }
    }
    async function handleSubmit() {
        if (!recaptchaVerifiedRegister.value) {
            Swal.fire({
                icon: "warning",
                title: "Captcha no verificado",
                text: "Por favor, completa la verificación del CAPTCHA para poder registrarte.",
                customClass: {
                    confirmButton: "swal-button--confirm-custom",
                },
            });
            return;
        }
        if (!validateCurrentStep()) {
            return;
        }
        // Obtener los elementos del DOM
        const registerButton = document.getElementById("registerButton");
        const loadingButton = document.getElementById("loadingButton");
        // Mostrar el botón de carga y ocultar el botón de registro
        if (registerButton)
            registerButton.style.display = "none";
        if (loadingButton)
            loadingButton.style.display = "inline-block";
        const registrationData = {
            nombre: form.value.step1.name,
            email: form.value.step1.email,
            password: form.value.step1.password,
            tipoUsuarioId: form.value.step1.accountType, // o el ID correspondiente
            nombreORazonSocial: form.value.step1.name,
            cedulaORif: form.value.step1.id,
            direccion: form.value.step2.address,
            ciudad: form.value.step2.city,
            estadoId: form.value.step2.state,
            numeroCelular: `${form.value.step2.prefixCelular}${form.value.step2.cellNumber}`,
            numeroWhatsapp: `${form.value.step2.prefixWhatsapp}${form.value.step2.cellNumber}`,
            numeroFijo: form.value.step3.landline,
            correoElectronico: form.value.step1.email,
            tipoComercioId: form.value.step3.commerceType,
            logotipoEmpresaMarca: "", // Agrega el logo si tienes este dato
            paginaWeb: form.value.step3.website,
            idInstagram: form.value.step3.instagramId,
            idTikTok: form.value.step3.tiktokId,
            nombreFacebook: form.value.step4.facebookName,
            nombreRepresentante: form.value.step4.representativeName,
            cedula: form.value.step4.representativeId,
            numeroTelefono: form.value.step4.representativePhone,
            cargo: form.value.step4.representativePosition,
        };
        try {
            await authService.register(registrationData);
            Swal.fire({
                title: "Registro completado",
                text: "Tu cuenta ha sido creada exitosamente.",
                icon: "success",
                customClass: {
                    confirmButton: "swal-button--confirm-custom",
                },
            });
            showSignIn(); // Cambia a la vista de inicio de sesión
        }
        catch (error) {
            let errorMessage = "Hubo un problema con el registro.";
            if (error instanceof Error) {
                errorMessage = error.message;
            }
            else if (error.response && error.response.data) {
                errorMessage = error.response.data.errores || errorMessage;
            }
            Swal.fire({
                title: "Error en el registro",
                text: errorMessage,
                icon: "error",
                customClass: {
                    confirmButton: "swal-button--confirm-custom",
                    cancelButton: "swal-button--cancel-custom", // Si necesitas un botón de cancelar
                },
            });
        }
        finally {
            // Ocultar el botón de carga y mostrar el botón de registro
            if (registerButton)
                registerButton.style.display = "inline-block";
            if (loadingButton)
                loadingButton.style.display = "none";
        }
    }
    async function handleLogin() {
        if (!recaptchaVerifiedLogin.value) {
            Swal.fire({
                icon: "warning",
                title: "Captcha no verificado",
                text: "Por favor, completa la verificación del CAPTCHA para poder iniciar sesion.",
                customClass: {
                    confirmButton: "swal-button--confirm-custom",
                },
            });
            return;
        }
        const loginData = {
            email: form.value.login.email,
            password: form.value.login.password,
        };
        // Referencia a los botones
        const loginButton = document.getElementById("loginButton");
        const loadingButton = document.getElementById("loadingButton");
        // Verificar si los botones existen antes de manipularlos
        if (loginButton && loadingButton) {
            try {
                // Ocultar el botón normal y mostrar el botón de carga
                loginButton.style.display = "none";
                loadingButton.style.display = "inline-block";
                const response = await authService.login(loginData);
                if (response) {
                    router.push("/");
                }
                // Maneja el almacenamiento de tokens y redirige o actualiza la interfaz según sea necesario
            }
            catch (error) {
                console.log(error);
                if (error instanceof Error) {
                    const errorMessage = error.message;
                    Swal.fire("Error en el inicio de sesión", errorMessage, "error");
                }
                else {
                    Swal.fire({
                        title: "Error en el inicio de sesión",
                        text: "Hubo un problema con el inicio de sesión.",
                        icon: "error",
                        customClass: {
                            confirmButton: "swal-button--confirm-custom",
                        },
                    });
                }
            }
            finally {
                // Restaurar el estado de los botones
                if (loginButton)
                    loginButton.style.display = "inline-block";
                if (loadingButton)
                    loadingButton.style.display = "none";
            }
        }
        else {
            console.error("No se encontraron los botones de inicio de sesión.");
        }
    }
    function showSignIn() {
        isActive.value = false;
        currentStep.value = 0; // Resetea el paso para el inicio de sesión
    }
    function showSignUp() {
        isActive.value = true;
        currentStep.value = 1; // Empieza en el primer paso del registro
    }
    return {
        recaptchaVerifiedLogin,
        recaptchaVerifiedRegister,
        isActive,
        currentStep,
        progress,
        form,
        errors,
        handleRecaptchaInputLogin,
        handleRecaptchaInputRegister,
        nextStep,
        previousStep,
        handleSubmit,
        handleLogin,
        showSignIn,
        showSignUp,
        showVerificationInput,
        isRequestingCode,
        isPhoneVerified,
        verificationCode,
        timeLeft,
        requestVerificationCode,
        verifyCode,
        resetPhoneNumber,
    };
}
